import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import { showError, showToast } from "../../helpers";
import {
  NotificationItem,
  useDeleteNotificationMutation,
  useLazyGetNotificationQuery,
} from "../../services/notification";
import DeleteConfirmationModal from "../../components/DeleteModal";
import Pagination from "../../components/Panigation";

const ManageNotifications = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [type, setType] = React.useState("default");
  const [totalCount, setTotalCount] = useState(0);
  const [notifications, setNotifications] = useState<NotificationItem[]>([]);
  const [notificationData] = useLazyGetNotificationQuery();

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const fetchList = async () => {
    try {
      const params: any = {
        page: page,
        limit: pageSize,
        search: debouncedSearchTerm,
        type: type === "default" ? undefined : Number(type),
      };
      const response = await notificationData(params).unwrap();
      if (response?.statusCode === 200) {
        setTotalCount(response?.data?.totalNotification || 0);
        setNotifications(response?.data?.notificationData || []);
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch Notification");
    }
  };

  useEffect(() => {
    fetchList();
  }, [page, pageSize, debouncedSearchTerm, type]);

  return (
    <>
      <div className="main_title">
        <h1>Notification & Communication Center</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Notification & Communication Center
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              value={searchTerm}
              onChange={(e: any) => setSearchTerm(e.target.value)}
              onCross={() => setSearchTerm("")}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select fullWidth value={type} onChange={handleTypeChange}>
                  <MenuItem disabled value="default">
                    Select Type
                  </MenuItem>
                  <MenuItem value="2">Broadcast</MenuItem>
                  <MenuItem value="1">Email</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-notifications/add")}
            >
              <AddIcon /> Add Notification
            </Button>
          </div>
        </div>
        <NotificationsList
          fetchList={fetchList}
          notifications={notifications}
        />
        <Pagination
          module={notifications || []}
          page={page}
          setPage={setPage}
          limit={pageSize}
          setLimit={setPageSize}
          onPageChange={(newPage: number) => setPage(newPage)}
          totalPages={Math.ceil(totalCount / pageSize)}
        />
      </div>
    </>
  );
};

export default ManageNotifications;
